import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

function NewCircleCheckmark({
  color = 'status.green',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase width='22' height='22' viewBox='0 0 22 22' {...props}>
      <Rect x='0.5' y='0.5' width='21' height='21' rx='10.5' fill={fill} />
      <Rect
        x='0.5'
        y='0.5'
        width='21'
        height='21'
        rx='10.5'
        stroke={color}
        fill={fill}
      />
      <Path
        d='
          M7.42969 11.3293
          L9.84753 13.8549
          L9.83191 13.8386
          L15.2868 8.14062
        '
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

NewCircleCheckmark.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default NewCircleCheckmark
